// extracted by mini-css-extract-plugin
export var productImage = "_lp-1";
export var viewLink = "_lp-2";
export var wishlistItem = "_lp-0";